var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGbsctFlag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 19,
    rx: 1.5,
    fill: "#316BDB",
    stroke: "#D5D6D8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_403_28741",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 24,
    height: 18
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 23,
    height: 17,
    rx: 0.5,
    fill: "#316BDB",
    stroke: "#D5D6D8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_403_28741)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1.25,
    y: 3.59814,
    width: 3,
    height: 30.75,
    transform: "rotate(-60 -1.25 3.59814)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 30.75,
    transform: "matrix(0.5 0.866025 0.866025 -0.5 -1.25 16.375)",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGbsctFlag);
export default __webpack_public_path__ + "static/media/gbsct-flag.07f1284b0c982f291e449fea42de658c.svg";
export { ForwardRef as ReactComponent };